export default __webpack_public_path__ + "static/media/chips.ece7a4db.svg";